import { API_URLS } from '../../../routes/urls';
import { apiSlice } from '../../apiSlice';
import { FetchEligibilitiesPayload, FetchEligibilitiesResponse } from './types';

const eligibilityApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchEligibilities: builder.query<FetchEligibilitiesResponse, FetchEligibilitiesPayload>({
      query: ({ ids, module }) => ({
        url: API_URLS.getEligibilities,
        params: { ids, module },
      }),
    }),
  }),
});

export const { useLazyFetchEligibilitiesQuery } = eligibilityApi;
